import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

const points = [
  "Private, exclusive STA Swim Star school",
  "Purpose-built teaching centre designed for comfort and calm",
  "Baby- and child-led learning that respects each child's pace",
  "Highly experienced, family-focused instructors",
  "A warm, community atmosphere where everyone feels at home",
  "A decade of trust, thousands of swimmers, countless magical moments",
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 bg-white" data-testid="about-section">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="rounded-[2.5rem] overflow-hidden shadow-xl">
              <img
                src={`${process.env.PUBLIC_URL}/about-why.jpg`}
                alt="Happy Tiddlers swimmer celebrating her graduation with siblings"
                className="w-full h-[440px] md:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 md:-right-8 w-40 h-40 rounded-[2rem] overflow-hidden border-8 border-white shadow-xl hidden sm:block">
              <img
                src="https://images.pexels.com/photos/1147124/pexels-photo-1147124.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Sparkling pool water"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-sm text-[#0EA5E9] tracking-[0.2em] uppercase font-bold">Why families choose us</span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight">
              Why families choose Happy Tiddlers
            </h2>
            <p className="mt-6 text-lg text-[#334155] leading-relaxed">
              For over a decade we've been part of the Barton-le-Clay community — and families
              choose us for the warmth, the trust and the care that runs through everything we do.
            </p>

            <ul className="mt-8 space-y-4">
              {points.map((pt) => (
                <li key={pt} className="flex items-start gap-3" data-testid="about-point">
                  <span className="grid place-items-center w-6 h-6 mt-0.5 rounded-full bg-[#0EA5E9] text-white shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="text-[#334155] text-lg">{pt}</span>
                </li>
              ))}
            </ul>

            <p className="mt-8 font-heading text-xl md:text-2xl font-semibold text-[#0A2540] leading-snug">
              Happy Tiddlers isn't just a swim school. It's a place where confidence begins,
              memories are made and families grow together.
            </p>

            <Link
              to="/contact"
              className="inline-block mt-9 bg-transparent text-[#0A2540] border-2 border-[#0A2540] font-bold px-8 py-4 rounded-full hover:bg-[#0A2540] hover:text-white transition-all duration-300"
              data-testid="about-cta"
            >
              Get in touch
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
